var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "dialog-main",
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            "modal-append-to-body": false,
            width: "620px",
            "before-close": _vm.onBeforeClose,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "typeForm",
              staticClass: "demo-form-inline",
              attrs: {
                model: _vm.typeForm,
                rules: _vm.rules,
                "label-width": "80px"
              }
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "一级分类",
                            prop: "materialTopTypeId"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择", size: "mini" },
                              model: {
                                value: _vm.typeForm.materialTopTypeId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.typeForm,
                                    "materialTopTypeId",
                                    $$v
                                  )
                                },
                                expression: "typeForm.materialTopTypeId"
                              }
                            },
                            _vm._l(_vm.oneOptions, function(item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.typeName, value: item.id }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "二级分类" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择",
                                size: "mini",
                                disabled: _vm.isTopEdit
                              },
                              model: {
                                value: _vm.typeForm.materialMiddleTypeId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.typeForm,
                                    "materialMiddleTypeId",
                                    $$v
                                  )
                                },
                                expression: "typeForm.materialMiddleTypeId"
                              }
                            },
                            _vm._l(_vm.twoOptions, function(item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.typeName, value: item.id }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "三级分类" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择",
                                size: "mini",
                                disabled: _vm.isMiddEdit
                              },
                              model: {
                                value: _vm.typeForm.materialDownTypeId,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.typeForm,
                                    "materialDownTypeId",
                                    $$v
                                  )
                                },
                                expression: "typeForm.materialDownTypeId"
                              }
                            },
                            _vm._l(_vm.threeOptions, function(item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: { label: item.typeName, value: item.id }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "排序值", prop: "orderNo" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入排序值",
                              size: "mini"
                            },
                            model: {
                              value: _vm.typeForm.orderNo,
                              callback: function($$v) {
                                _vm.$set(_vm.typeForm, "orderNo", _vm._n($$v))
                              },
                              expression: "typeForm.orderNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "mass-content" },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  clearable: "",
                  autocomplete: "off",
                  size: "small",
                  maxlength: "200",
                  "show-word-limit": ""
                },
                model: {
                  value: _vm.material.content,
                  callback: function($$v) {
                    _vm.$set(_vm.material, "content", $$v)
                  },
                  expression: "material.content"
                }
              }),
              _c(
                "div",
                { staticClass: "upload-image-wrap" },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        multiple:
                          this.currentUploadType == "img" ? true : false,
                        "auto-upload": false,
                        limit: _vm.limit,
                        action: "#",
                        accept: _vm.acceptText,
                        "on-change": _vm.onChange,
                        "on-exceed": _vm.exceed,
                        "on-remove": _vm.uploadImageRemove,
                        "on-preview": _vm.previewImage,
                        "file-list": _vm.fileList
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "trigger",
                            size: "small",
                            icon: "el-icon-plus",
                            type: "plain",
                            disabled: _vm.handleDisabled("img")
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleUpload("img")
                            }
                          },
                          slot: "trigger"
                        },
                        [_vm._v("添加图片")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "trigger",
                            size: "small",
                            icon: "el-icon-plus",
                            type: "plain",
                            disabled: _vm.handleDisabled("mp4")
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleUpload("mp4")
                            }
                          },
                          slot: "trigger"
                        },
                        [_vm._v("添加视频")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            slot: "trigger",
                            size: "small",
                            icon: "el-icon-plus",
                            type: "plain",
                            disabled: _vm.handleDisabled("file")
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleUpload("file")
                            }
                          },
                          slot: "trigger"
                        },
                        [_vm._v("上传文档")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: {
                            size: "small",
                            icon: "el-icon-plus",
                            type: "plain",
                            disabled: _vm.handleDisabled("link")
                          },
                          on: {
                            click: function($event) {
                              return _vm.handleSetingLint("link")
                            }
                          }
                        },
                        [_vm._v("设置链接")]
                      ),
                      _c(
                        "p",
                        {
                          staticStyle: {
                            color: "#9f9fb8",
                            display: "block",
                            "font-size": "12px",
                            "margin-top": "4px"
                          }
                        },
                        [
                          _vm._v(" *温馨提示： "),
                          _c("br"),
                          _vm._v(" 1 选择素材时，只能选择其中一种； "),
                          _c("br"),
                          _vm._v(" 2 建议图片大小不超过2M，格式为jpg、png； "),
                          _c("br"),
                          _vm._v(" 3 视频大小不超过10M，格式为mp4； "),
                          _c("br"),
                          _vm._v(
                            " 4 文档大小不超过20M，格式为doc、xlsx、xls、ppt、pdf； "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm.linkList.length != 0
                    ? _c("div", { staticClass: "link-wrap" }, [
                        _c("div", { staticClass: "link-item" }, [
                          _c("div", { staticClass: "item-left" }, [
                            _c("div", { staticClass: "title" }, [
                              _vm._v(_vm._s(_vm.myFormLink.title))
                            ]),
                            _vm.myType != 3
                              ? _c("div", { staticClass: "content" }, [
                                  _vm._v(
                                    " " + _vm._s(_vm.myFormLink.content) + " "
                                  )
                                ])
                              : _vm._e()
                          ]),
                          _c(
                            "div",
                            { staticClass: "item-right" },
                            [
                              _vm.myFormLink.pictureUrl
                                ? _c("el-image", {
                                    staticClass: "photo",
                                    attrs: { src: _vm.myFormLink.fileFullUrl }
                                  })
                                : _vm._e()
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "close-wrap",
                              on: { click: _vm.deletePhoto }
                            },
                            [
                              _c("span", {
                                staticClass: "el-icon-close close-icon"
                              })
                            ]
                          )
                        ])
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-right": "20px" },
                  attrs: { size: "small" },
                  on: {
                    click: function($event) {
                      return _vm.onBeforeClose("取消")
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: { click: _vm.determine }
                },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("ConfirmTipDialog", {
        ref: "confirmTipDialog",
        on: { levelconfirm: _vm.levelconfirm }
      }),
      _c("SaveErrorTIp", { ref: "saveErrorTIp" }),
      _c(
        "el-dialog",
        {
          staticClass: "video-dialog",
          staticStyle: { "margin-top": "0vh" },
          attrs: {
            visible: _vm.videoShow,
            width: "400px",
            "close-on-click-modal": "",
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.videoShow = $event
            }
          }
        },
        [
          _vm.fileList.length != 0
            ? _c(
                "video",
                {
                  attrs: { width: "100%", height: "auto", controls: "controls" }
                },
                [
                  _c("source", {
                    attrs: { src: _vm.videoUrl, type: "video/mp4" }
                  })
                ]
              )
            : _vm._e()
        ]
      ),
      _c("NewLink", { ref: "newLink", on: { comfirm: _vm.linkComfirm } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }